import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MetaGuard } from 'meta'
import { SearchComponent } from './search.component'
import { OldSearchAnalyticsService, SEARCH_LIST_TAG } from '../libs/_deprecated/search/old-search-analytics.service'
import { NextGenUniversalGuard } from '../shared/guards/next-gen-universal.guard'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: SearchComponent,
        canActivate: [NextGenUniversalGuard, MetaGuard],
        data: {
          noTopScroll: false,
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          meta: {
            title: 'meta_search_page_title',
            description: 'meta_search_page_description'
          },
          /**
           * This will both prevent automatic page calls and also allow the
           * analytics directive to work for track calls.
           *
           * @see outExcludedRoutes
           */
          segment: SEARCH_LIST_TAG
        }
      }
    ])
  ],
  exports: [RouterModule],
  providers: [OldSearchAnalyticsService]
})
export class SearchRoutingModule {}
